import { useCallback } from 'react';

import {
  setSelectedOption,
  resetSelectedOption as resetSelectedOptionAction,
} from '../../../../store/reducers/student/tracking/questionWidgetTrackingActions';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { useContentBlocksContext } from '../../ContentBlocksContext';
import { getSavedOptionsForQuestionWidget } from '../_shared/Question/api/getSavedOptionsForQuestion';
import { SingleResponseQuestionWidget } from '@ael/core-api';
import { useDispatch } from 'react-redux';

export const useGetSavedOptionForQuestionWidget = (questionWidget: SingleResponseQuestionWidget) => {
  const { contentItem } = useContentBlocksContext();
  const dispatch = useDispatch();
  const setOption = useCallback(
    (questionWidget: SingleResponseQuestionWidget, index: number) => {
      dispatch(setSelectedOption(contentItem, questionWidget, index));
    },
    [contentItem, dispatch]
  );
  const resetOption = useCallback(
    (questionWidget: SingleResponseQuestionWidget) => {
      dispatch(resetSelectedOptionAction(contentItem, questionWidget));
    },
    [contentItem, dispatch]
  );

  const { saveSelectedOption, previouslySelectedOptionIndex, resetSelectedOption } = useStudentSelector(
    getSavedOptionsForQuestionWidget(setOption, resetOption)
  )(contentItem, questionWidget);

  return {
    saveSelectedOption,
    previouslySelectedOptionIndex,
    resetSelectedOption,
  };
};
